'use client';

import { createContext } from 'react';

import { useCookie, useMount } from '../hooks';
import { getUtmCookieOptions, UTM_COOKIE_NAME, utmFromUrl } from '../utils';

type UtmContextProps = Record<string, string> | null;

export const UtmContext = createContext<UtmContextProps>(null);

export function UtmProvider({ children }: React.PropsWithChildren) {
	const [utm, setUtm] = useCookie<UtmContextProps>(UTM_COOKIE_NAME, null);

	useMount(() => {
		const searchParams = new URLSearchParams(window.location.search);
		const utm = utmFromUrl(searchParams);

		if (utm) {
			setUtm(utm, getUtmCookieOptions());
		}
	});

	return <UtmContext.Provider value={utm}>{children}</UtmContext.Provider>;
}
